import { Stack } from '@backyard-ui/core';

import { type Installment } from '@/infra/services/catalog/model';

import PaymentRow from './PaymentRow';

interface PaymentMethodsProps {
  price: number;
  installments: Installment[] | null;
}

const PaymentMethods = (props: PaymentMethodsProps) => {
  const { price, installments } = props;

  const hasInstallments = installments != null && installments.length > 0;

  if (hasInstallments) {
    return (
      <Stack direction="column" spacing="0.5">
        {installments.map((installment, index) => (
          <PaymentRow key={index} installment={installment} />
        ))}
      </Stack>
    );
  }

  return (
    <Stack direction="column" spacing="0.5">
      <PaymentRow installment={{ quantity: 1, price, totalPrice: price }} />
    </Stack>
  );
};

export default PaymentMethods;
